import(/* webpackMode: "eager" */ "/tmp/build_6fc63030/app/globals.css");
;
import(/* webpackMode: "eager" */ "/tmp/build_6fc63030/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_6fc63030/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_6fc63030/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_6fc63030/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/tmp/build_6fc63030/node_modules/slick-carousel/slick/slick.css");
;
import(/* webpackMode: "eager" */ "/tmp/build_6fc63030/node_modules/slick-carousel/slick/slick-theme.css");
